module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vfooter"
  }, [_c('div', {
    staticClass: "footer-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "contact"
  }, [_c('p', [_c('a', {
    staticClass: "mail",
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("关于我们")]), _vm._v("　|　"), _c('a', {
    staticClass: "mail",
    attrs: {
      "href": "/volunteers"
    }
  }, [_vm._v("志愿者招募")])]), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/tel.svg")
    }
  }), _vm._v("联系小助手：132 6332 1278")]), _c('p', [_c('a', {
    staticClass: "mail",
    attrs: {
      "href": "mailto:thefrontier@geekpark.net"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/mail.svg")
    }
  }), _vm._v("thefrontier@geekpark.net")])]), _c('p', {
    staticClass: "site"
  }, [_vm._v("Powered by "), _c('a', {
    attrs: {
      "href": "http://www.geekpark.net",
      "target": "_blank"
    }
  }, [_vm._v("GeekPark")])])]), _c('div', {
    staticClass: "follow"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/qrcode.jpg"),
      "alt": "前沿社公众号"
    }
  }), _c('br'), _vm._v("关注前沿社公众号"), _c('br'), _vm._v("开启认知之旅")])])])]), _c('div', {
    staticClass: "footer-copyright"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', [_vm._v("京ICP备 13016923号-2   京公网安备 110105001682号")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fa9f636!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vfooter.vue
// module id = 198
// module chunks = 1